export default __webpack_public_path__ + "static/media/brh.e52dd219.svg";